import React from 'react';
import {
  useLocation,
} from 'react-router';
import {
  useObserver,
} from 'mobx-react';
import * as yup from 'yup';
import GeneralFormView from '../../components/GeneralFormView';
import GeneralFormFields from '../../components/GeneralFormView/types';
import {
  FormFieldsBuilder,
} from '../../components/GeneralFormView/Utils/FormFieldsBuilder';
import {
  FieldFile, isRemoteFile,
} from '../../components/GeneralFormView/FormField/types';
import {
  uploadSingleFile,
} from '../../helperFunctions/uploadService';
import {
  RequestStatus,
  stores,
} from '../../mobx-store';
import {
  BranchFeatureDTO,
} from './DTOs/branchFeatureDTO';
import {
  BranchFeatureFormViewModel,
} from './DTOs/branchFeatureFormViewModel';
import {
  languageCodes,
} from '../../constants/languages';

const AddEditBranchFeatureScreen: React.FC = () => {
  const mapToDTO = async (formValue: BranchFeatureFormViewModel): Promise<BranchFeatureDTO> => {
    let iconURL: string;
    if (formValue.icon && formValue.icon.length) {
      if (isRemoteFile(formValue.icon[0])) {
        iconURL = formValue.icon[0].source;
      } else {
        iconURL = await uploadSingleFile(formValue.icon[0].file);
      }
    } else {
      iconURL = '';
    }
    return {
      branchFeatureId: formValue.branchFeatureId,
      title: formValue.title,
      iconURL,
    };
  };
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const paramLang = queryParams.get('lang');

  const {
    formFields,
  } = new FormFieldsBuilder<BranchFeatureFormViewModel>()
    .addField('title', {
      hasTranslations: true,
      title: paramLang === languageCodes.arabic ? 'Arabic Title' : 'English Title',
      type: GeneralFormFields.INPUT_FIELD,
      fieldOptions: {
      },
      validationSchema: yup.string().required('Required'),
    })
    .addField('icon', {
      title: 'Icon',
      type: GeneralFormFields.FILE_PICKER,
      fieldOptions: {
        size: 200,
        accept: 'image/*',
        multipleImages: false,
      },
      validationSchema: yup.array<FieldFile>().optional(),
    });

  return useObserver(() => (
    <GeneralFormView<BranchFeatureDTO, BranchFeatureFormViewModel>
      defaultLang="ar"
      title="Branch Feature"
      identifier="branchFeatureId"
      otherLanguages={['en']}
      formData={formFields}
      create={async (formValue) => {
        const dto = await mapToDTO(formValue);
        const res = await stores.branchFeatureStore.createNewBranchFeature(dto);
        return res;
      }}
      update={async (id, formValue, language) => {
        const dto = await mapToDTO(formValue);
        await stores.branchFeatureStore.updateBranchFeatureById(Number(id), dto, language);
      }}
      get={async (id, language) => {
        await stores.branchFeatureStore.getBranchFeatureById(Number(id), language);
        return new BranchFeatureFormViewModel(stores.branchFeatureStore.currentBranchFeature as BranchFeatureDTO);
      }}
      isFetchSuccessful={stores.branchFeatureStore.CRUDStatus === RequestStatus.SUCCESS}
      createOrUpdateStatus={stores.branchFeatureStore.CRUDStatus}
    />
  ));
};

export default AddEditBranchFeatureScreen;
